<svg viewBox="0 0 1200 230" role="img" [attr.aria-label]="'Brazil fiscal chart for ' + row.year">
    @for (level of [1, 4, 7, 10]; track level) {
      <text x="8" [attr.y]="192 - ((level - 1) / 9) * 156">{{ level }}</text>
    }
    <line class="axis" x1="44" x2="1156" y1="200" y2="200" />
    @for (month of months; track month; let index = $index) {
      <line class="month-divider" [attr.x1]="44 + index / 12 * 1112" [attr.x2]="44 + index / 12 * 1112" y1="194" y2="204" />
      <text class="month-label" [attr.x]="monthX(index)" y="222">{{ month }}</text>
    }
    <line class="month-divider" x1="1156" x2="1156" y1="194" y2="204" />

    @for (series of visibleSeries; track series.key) {
      <polyline class="data-line" [class.employment]="series.key === 'employment'"
        [class.inflation-target]="series.key === 'inflationTarget'"
        [attr.stroke]="series.color" [attr.stroke-dasharray]="series.dash" [attr.points]="points(series)" />
      @for (week of series.weeks; track week.weekStart) {
        @if (week.score !== null) {
          <circle class="data-dot" [attr.fill]="series.color" [attr.cx]="x(week.lastObservation)"
            [attr.cy]="y(week.score)" r="2">
            <title>{{ series.label }} · {{ week.lastObservation }} · {{ week.close | number:'1.0-2' }} · score {{ week.score | number:'1.1-1' }}</title>
          </circle>
        }
      }
    }
    @for (decision of row.policyDecisions; track decision.meetingNumber) {
      <line class="rate-line" [class.extraordinary]="decision.extraordinary"
        [attr.x1]="x(decision.date)" [attr.x2]="x(decision.date)" y1="20" y2="194" />
      <circle class="rate-dot" [class.hold]="decision.changePoints === 0"
        [attr.cx]="x(decision.date)" cy="12" r="4">
        <title>Copom {{ decision.meetingNumber }} · {{ decision.date }} · Selic {{ decision.rate }}% · {{ decisionLabel(decision) }}</title>
      </circle>
    }
</svg>
